import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonAsync, muiRipple } from '@subaio/components'

import { helpers } from 'styles'

export const ButtonOutline = styled(ButtonAsync)`
	color: ${helpers.color.primary};
	background-color: transparent;
	border: 2px solid ${helpers.color.primary};
	font-family: ${helpers.font.family.header};
	font-size: ${helpers.font.size.base};
	margin: 0;

	border-radius: 40px;
	min-width: 125px;
	height: 40px;
	padding-left: 16px;
	padding-right: 16px;
	transition: color 0.2s, background-color 0.2s, border-color 0.2s;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme }) => transparentize(0.83, theme.color.primary)};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		border-color: ${helpers.color.disabled};
		color: ${helpers.color.disabled};
	}

	${muiRipple()}
`
